import { useLocation } from "wouter";
import { track } from "../../../lib/analytics";

export function LandingFooter() {
  const [, navigate] = useLocation();

  const links = [
    { label: "Nouveautés", path: "/releases" },
    { label: "Roadmap", path: "/roadmap" },
    { label: "Mentions légales", path: "/legal" },
    { label: "Confidentialité", path: "/privacy" },
  ];

  return (
    <footer className="py-6 px-6 border-t border-border">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex flex-col gap-1">
          <span className="text-xs text-ink-faint">&copy; {new Date().getFullYear()} Palnia</span>
          <span className="text-[10px] text-ink-faint/50">Le nom et le logo sont provisoires.</span>
        </div>
        <div className="flex items-center gap-4 text-xs text-ink-faint">
          {links.map((link) => (
            <button
              key={link.path}
              type="button"
              onClick={() => { track("landing_footer_clicked", { link: link.label }); navigate(link.path); }}
              className="hover:text-ink transition-colors"
            >
              {link.label}
            </button>
          ))}
        </div>
      </div>
    </footer>
  );
}
